<template>
  <div>
    <v-row
      v-if="isLoading"
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-col class="subtitle-1 text-center" cols="12">
        Загрузка...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="indigo"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
    <router-view v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { routes } from '@/router'

export default {
  computed: {
    ...mapGetters('auth', ['currentUser']),
    isLoading() {
      return !this.currentUser
    }
  },
  created() {
    if (this.currentUser && !this.currentUser.is_superuser) {
      this.$router.push({ name: routes.dashboard })
    }
  }
}
</script>
